// Toggles edge-fade state on horizontally scrollable section content.
// Adds data-can-scroll-start / data-can-scroll-end based on scroll position
// so the CSS mask only fades the side where more content exists.
(function () {
  const SELECTOR = '.mobile-h-scroll';
  const EPSILON = 1;

  function update(el) {
    const max = el.scrollWidth - el.clientWidth;
    const x = el.scrollLeft;
    // Only force start-alignment while the row actually overflows; when it fits,
    // the configured horizontal alignment (direction) is respected.
    el.toggleAttribute('data-overflowing', max > EPSILON);
    el.toggleAttribute('data-can-scroll-start', x > EPSILON);
    el.toggleAttribute('data-can-scroll-end', x < max - EPSILON);
  }

  function init(el) {
    if (el.dataset.hScrollReady) return;
    el.dataset.hScrollReady = 'true';

    const onUpdate = () => update(el);
    el.addEventListener('scroll', onUpdate, { passive: true });
    window.addEventListener('resize', onUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(onUpdate).observe(el);
    }

    update(el);
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Re-init when a section is added/reloaded in the theme editor.
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
